"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Game_1 = require("./Game");
const KHContainer_1 = require("./KH/KHContainer");
const PrimaryColor = 0x0;
const SecondaryColor = 0xffffff;
const CornerWidth = 2 / 75;
const ClickExpansion = 5;
class ATTextButton extends KHContainer_1.KHContainer {
    constructor(scene, x, y, w, h, text) {
        super(scene, x, y, w, h);
        this.graphics = scene.add.graphics();
        this.add(this.graphics);
        this.text = scene.add.dom(w / 2, h / 2, 'div', Game_1.game.fontStyleWithColor(0.7 * h, PrimaryColor), text).setOrigin(0.5, 0.5);
        this.add(this.text);
        this.setInverted(false);
    }
    drawGraphics(primary, secondary) {
        this.graphics.fillStyle(secondary, 1);
        this.graphics.fillRoundedRect(0, 0, this.c_w, this.c_h, CornerWidth * this.c_h);
        this.graphics.lineStyle(6 / 75 * this.c_h, primary, 1);
        this.graphics.strokeRoundedRect(0, 0, this.c_w, this.c_h, CornerWidth * this.c_h);
    }
    setInteractable(interact) {
        if (interact) {
            this.setInteractive(new Phaser.Geom.Rectangle(-ClickExpansion, -ClickExpansion, this.c_w + ClickExpansion * 2, this.c_h + ClickExpansion * 2), Phaser.Geom.Rectangle.Contains);
        }
        else {
            this.removeInteractive();
        }
    }
    setInverted(inverted) {
        this.drawGraphics(inverted ? SecondaryColor : PrimaryColor, inverted ? PrimaryColor : SecondaryColor);
        // this.text.createElement('div', game.fontStyleWithColor(0.9 * this.c_h, inverted ? SecondaryColor : PrimaryColor)).setOrigin(0.5, 0.5);
    }
}
exports.default = ATTextButton;
